/** Default number of items per page for paginated list views. */
export const ITEMS_PER_PAGE = 30
